import { createFileRoute } from "@tanstack/react-router";
import { MarketDetailView } from "@/components/markets/MarketDetailView";
import { marketMetaLoader, marketHeadFromLoader } from "@/lib/marketSeo";

export const Route = createFileRoute("/_app/markets/$id")({
  // Market-specific link metadata (SM-381). Non-blocking — see
  // src/lib/marketSeo.ts for why, and for which audience gets the
  // server-rendered version.
  loader: marketMetaLoader,
  head: marketHeadFromLoader((id) => `/markets/${id}`),
  validateSearch: (
    s: Record<string, unknown>,
  ): { tab?: string; range?: string; trade?: string; side?: "buy" | "sell"; pos?: number } => ({
    tab: typeof s.tab === "string" ? s.tab : undefined,
    range: typeof s.range === "string" ? s.range : undefined,
    // Trade intent: the member market + its outcome index (pos). side="buy" (a
    // card Yes/No tap) preselects it; side="sell" (portfolio "Sell") pins SELL.
    trade: typeof s.trade === "string" ? s.trade : undefined,
    side: s.side === "sell" || s.side === "buy" ? s.side : undefined,
    pos: s.pos == null ? undefined : Number.isFinite(Number(s.pos)) ? Number(s.pos) : undefined,
  }),
  component: MarketDetail,
});

// Home-context detail page. "Back" pops the history stack (you came from the
// feed, watchlist, search, …). The Explore-scoped copy lives at /explore/$id.
function MarketDetail() {
  const { id } = Route.useParams();
  const { trade, side, pos } = Route.useSearch();
  return (
    <MarketDetailView
      id={id}
      back={{ kind: "history" }}
      tradeIntent={trade ? { marketId: trade, pos: pos ?? 0, side: side ?? "buy" } : undefined}
    />
  );
}
